import React, { useState } from 'react';
import { api } from '../services/api';

export default function BrowserExtension() {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    try {
      setDownloading(true);
      setError(null);
      
      // Call the API to download the extension
      const blob = await api.downloadExtension();
      
      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'windmill-extension.zip';
      document.body.appendChild(a);
      a.click();
      
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      setError(err.message || 'Failed to download extension');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div>
      {error && (
        <div className="notification notification-error" style={{ marginBottom: '1rem' }}>
          {error}
        </div>
      )}

      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ 
          fontSize: '1.25rem', 
          fontWeight: '600', 
          marginBottom: '0.75rem',
          color: 'var(--text-primary)'
        }}>
          Browser Extension
        </h3>
        <p style={{ 
          fontSize: '0.875rem', 
          color: 'var(--text-secondary)', 
          marginBottom: '1.5rem',
          lineHeight: '1.6'
        }}>
          Install the Windmill browser extension to create tasks from anywhere in Chrome. 
          Right-click on any text to quickly add it as a task to your lists.
        </p>

        <div style={{
          background: 'var(--bg-hover)',
          border: '1px solid var(--border-light)',
          borderRadius: 'var(--radius-lg)',
          padding: '1.5rem',
          marginBottom: '1.5rem'
        }}>
          <h4 style={{ 
            fontSize: '1rem', 
            fontWeight: '600', 
            marginBottom: '1rem',
            color: 'var(--text-primary)'
          }}>
            Installation Instructions
          </h4>
          <ol style={{ 
            margin: 0, 
            paddingLeft: '1.5rem',
            fontSize: '0.875rem',
            color: 'var(--text-secondary)',
            lineHeight: '1.8'
          }}>
            <li style={{ marginBottom: '0.75rem' }}>
              Click the download button below to download the extension ZIP file
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              Open Chrome and navigate to <code style={{ 
                background: 'var(--bg-card)', 
                padding: '0.125rem 0.375rem', 
                borderRadius: '4px',
                fontSize: '0.8rem',
                fontFamily: 'monospace',
                border: '1px solid var(--border-color)'
              }}>chrome://extensions/</code>
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              Enable "Developer mode" in the top right corner
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              Click "Load unpacked" and select the extracted extension folder
            </li>
            <li>
              The login page will automatically open when you install the extension. Sign in with Google to get started.
            </li>
          </ol>
        </div>

        <button
          onClick={handleDownload}
          disabled={downloading}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            fontWeight: '600',
            color: 'white',
            background: downloading ? '#94a3b8' : 'var(--primary-color)',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            cursor: downloading ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease',
            minWidth: '200px'
          }}
          onMouseEnter={(e) => {
            if (!downloading) {
              e.target.style.background = 'var(--primary-dark)';
              e.target.style.transform = 'translateY(-1px)';
            }
          }}
          onMouseLeave={(e) => {
            if (!downloading) {
              e.target.style.background = 'var(--primary-color)';
              e.target.style.transform = 'translateY(0)';
            }
          }}
        >
          {downloading ? (
            <>
              <div className="spinner" style={{ width: '16px', height: '16px' }}></div>
              <span>Downloading...</span>
            </>
          ) : (
            <>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M10 3v10m0 0l-4-4m4 4l4-4M3 17h14" />
              </svg>
              <span>Download Extension</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}

